// export const TEAM_NEEDS = [
//   {
//     name: "Cardinals",
//     color: "#D50A0A",
//     loc: "ARI",
//   },
//   {
//     name: "Falcons",
//     color: "#B60404",
//     loc: "ATL",
//   },
//   {
//     name: "Bills",
//     color: "#446BB5",
//     loc: "BUF",
//   },
//   {
//     name: 'Ravens',
//     color: '#5586E1',
//     loc:'BAL'
//   },
//   {
//     name: 'Panthers',
//     color: '#015098',
//     loc:'CAR'
//   },
//   {
//     name: 'Bears',
//     color: '#2C2AA0',
//     loc:'CHI'
//   },
//   {
//     name: 'Bengals',
//     color: '#DE4300',
//     loc:'CIN'
//   },
//   {
//     name: 'Browns',
//     color: '#782907',
//     loc:'CLE'
//   },
//   {
//     name: 'Cowboys',
//     color: '#263A57',
//     loc:'DAL'
//   },
//   {
//     name: 'Broncos',
//     color: '#D5470A',
//     loc:'DEN'
//   },
//   {
//     name: 'Lions',
//     color: '#0456B6',
//     loc:'DET'
//   },
//   {
//     name: 'Packers',
//     color: '#1B371E',
//     loc:'GB'
//   },
//   {
//     name: 'Texans',
//     color: '#100A54',
//     loc:'HOU'
//   },
//   {
//     name: 'Colts',
//     color: '#015098',
//     loc:'IND'
//   },
//   {
//     name: 'Jaguars',
//     color: '#006779',
//     loc:'JAC'
//   },
//   {
//     name: 'Chiefs',
//     color: '#B60F28',
//     loc:'Chiefs'
//   },
//   {
//     name: 'Raiders',
//     color: '#484644',
//     loc:'LV'
//   },
//   {
//     name: 'Chargers',
//     color: '#0670AC',
//     loc:'LAC'
//   },
//   {
//     name: 'Rams',
//     color: '#0A8CD5',
//     loc:'LAR'
//   },
//   {
//     name: 'Dolphins',
//     color: '#168D96',
//     loc:'MIA'
//   },
//   {
//     name: 'Vikings',
//     color: '#5D2A9E',
//     loc:'MIN'
//   },
//   {
//     name: 'Patriots',
//     color: '#1F4367',
//     loc:'NE'
//   },
//   {
//     name: 'Saints',
//     color: '#CB962B',
//     loc:'NO'
//   },
//   {
//     name: 'Giants',
//     color: '#6361CE',
//     loc:'NYG'
//   },
//   {
//     name: 'Jets',
//     color: '#2D775F',
//     loc:'NYJ'
//   },
//   {
//     name: 'Eagles',
//     color: '#00000D',
//     loc:'PHI'
//   },
//   {
//     name: 'Steelers',
//     color: '#263A57',
//     loc:'PIT'
//   },
//   {
//     name: '49ers',
//     color: '#D50A0A',
//     loc:'SF'
//   },
//   {
//     name: 'Seahawks',
//     color: '#0A1F89',
//     loc:'SEA'
//   },
//   {
//     name: 'Buccaneers',
//     color: '#B93E2D',
//     loc:'TB'
//   },
//   {
//     name: 'Titans',
//     color: '#446BB5',
//     loc:'TEN'
//   },
//   {
//     name: 'Commanders',
//     color: '#631A1A',
//     loc:'WAS'
//   },
//   {
//     name: 'Bucaneers',
//     color: '#a31d2f',
//     loc:'BUC'
//   },
// ];
export const TEAM_NEEDS = [
	{
		name: 'Cardinals',
		color: '#D50A0A',
		loc: 'ARI',
		gradient: 'linear-gradient(127deg, #B0063A 0%, #FFC20E 100%);',
	},
	{
		name: 'Falcons',
		color: '#B60404',
		loc: 'ATL',
		gradient: 'linear-gradient(127deg, #C9243F 0%, #000 100%);',
	},
	{
		name: 'Bills',
		color: '#446BB5',
		loc: 'BUF',
		gradient: 'linear-gradient(127deg, #DA2128 0%, #005596 100%);',
	},
	{
		name: 'Ravens',
		color: '#5586E1',
		loc: 'BAL',
		gradient: 'linear-gradient(127deg, #D2AA41 0%, #2C2E8C 100%);',
	},
	{
		name: 'Panthers',
		color: '#015098',
		loc: 'CAR',
		gradient: 'linear-gradient(127deg, #0099D7 0%, #000 100%);',
	},
	{
		name: 'Bears',
		color: '#2C2AA0',
		loc: 'CHI',
		gradient: 'linear-gradient(127deg, #F26522 0%, #00123F 100%);',
	},
	{
		name: 'Bengals',
		color: '#DE4300',
		loc: 'CIN',
		gradient: 'linear-gradient(127deg, #F04E23 0%, #000 100%);',
	},
	{
		name: 'Browns',
		color: '#782907',
		loc: 'CLE',
		gradient: 'linear-gradient(127deg, #FF3C00 0%, #311D00 100%);',
	},
	{
		name: 'Cowboys',
		color: '#263A57',
		loc: 'DAL',
		gradient: 'linear-gradient(127deg, #00295B 0%, #FFF 100%);',
	},
	{
		name: 'Broncos',
		color: '#D5470A',
		loc: 'DEN',
		gradient: 'linear-gradient(127deg, #F05523 0%, #001F52 100%);',
	},
	{
		name: 'Lions',
		color: '#0456B6',
		loc: 'DET',
		gradient: 'linear-gradient(127deg, #0076B6 0%, #B0B7BB 100%);',
	},
	{
		name: 'Packers',
		color: '#1B371E',
		loc: 'GB',
		gradient: 'linear-gradient(127deg, #203731 0%, #FFB612 100%);',
	},
	{
		name: 'Texans',
		color: '#100A54',
		loc: 'HOU',
		gradient: 'linear-gradient(127deg, #00123F 0%, #C9243F 100%);',
	},
	{
		name: 'Colts',
		color: '#015098',
		loc: 'IND',
		gradient: 'linear-gradient(127deg, #00427E 0%, #FFF 100%);',
	},
	{
		name: 'Jaguars',
		color: '#006779',
		loc: 'JAC',
		gradient: 'linear-gradient(127deg, #006577 0%, #D6A22A 100%);',
	},
	{
		name: 'Chiefs',
		color: '#B60F28',
		loc: 'Chiefs',
		gradient: 'background: linear-gradient(127deg, #C9243F 0%, #FFF 100%);',
	},
	{
		name: 'Raiders',
		color: '#484644',
		loc: 'LV',
		gradient: 'linear-gradient(127deg, #A8A8AA 0%, #040707 100%);',
	},
	{
		name: 'Chargers',
		color: '#0670AC',
		loc: 'LAC',
		gradient: 'linear-gradient(127deg, #1281C4 0%, #FFC313 100%);',
	},
	{
		name: 'Rams',
		color: '#0A8CD5',
		loc: 'LAR',
		gradient: 'linear-gradient(127deg, #003593 0%, #FFD100 100%);',
	},
	{
		name: 'Dolphins',
		color: '#168D96',
		loc: 'MIA',
		gradient: 'linear-gradient(127deg, #008E97 0%, #FC4C02 100%);',
	},
	{
		name: 'Vikings',
		color: '#5D2A9E',
		loc: 'MIN',
		gradient: 'linear-gradient(127deg, #4E2683 0%, #FFC423 100%);',
	},
	{
		name: 'Patriots',
		color: '#1F4367',
		loc: 'NE',
		gradient: 'linear-gradient(127deg, #DA2128 0%, #00295B 100%);',
	},
	{
		name: 'Saints',
		color: '#CB962B',
		loc: 'NO',
		gradient: 'linear-gradient(127deg, #C8AA76 0%, #000 100%);',
	},
	{
		name: 'Giants',
		color: '#6361CE',
		loc: 'NYG',
		gradient: 'linear-gradient(127deg, #003D7E 0%, #7B7B7B 47.5%, #003D7E 100%);',
	},
	{
		name: 'Jets',
		color: '#2D775F',
		loc: 'NYJ',
		gradient: 'linear-gradient(127deg, #115740 0%, #FFF 100%);',
	},
	{
		name: 'Eagles',
		color: '#00000D',
		loc: 'PHI',
		gradient: 'linear-gradient(127deg, #004C55 0%, #000 100%);',
	},
	{
		name: 'Steelers',
		color: '#263A57',
		loc: 'PIT',
		gradient: 'linear-gradient(127deg, #DA2128 0%, #FFC20E 50%, #004F93 100%);',
	},
	{
		name: '49ers',
		color: '#D50A0A',
		loc: 'SF',
		gradient: 'linear-gradient(127deg, #B8083E 0%, #C8AA76 100%);',
	},
	{
		name: 'Seahawks',
		color: '#0A1F89',
		loc: 'SEA',
		gradient: 'linear-gradient(127deg, #002A5C 0%, #7AC142 100%);',
	},
	{
		name: 'Buccaneers',
		color: '#B93E2D',
		loc: 'TB',
		gradient: 'linear-gradient(127deg, #A31D2F 0%, #DC4726 50%, #FFF 100%);',
	},
	{
		name: 'Titans',
		color: '#446BB5',
		loc: 'TEN',
		gradient: 'linear-gradient(127deg, #DA2128 0%, #4295D1 63.84%, #00295B 100%);',
	},
	{
		name: 'Commanders',
		color: '#631A1A',
		loc: 'WAS',
		gradient: 'linear-gradient(127deg, #5A1313 0%, #FFB612 100%, #35689F 100.01%);',
	},
	{
		name: 'Buccaneers',
		color: '#a31d2f',
		loc: 'BUC',
		gradient: 'linear-gradient(127deg, #A31D2F 0%, #DC4726 50%, #FFF 100%);',
	},
];

export const POSITIONS_COLOR_OLD = {
	All: '',
	QB: '#E7E9EB',
	WR: '#F9F2D9',
	TE: '#E7D1DB',
	RB: '#EAF0E7',
	OT: '#F1F1E6',
	CB: '#D9BDE3',
	S: '#FAEBA7',
	DL: '#B4EECD',
	EDGE: '#EDE0EB',
	LB: '#DCE6EE',
	iOL_C: '#F2E2DE',
	iOL: '#ACE8DC',
	P: '#F8E8D9',
	K: '#FAEBA7',
};

export const POSITIONS_COLOR = {
    All: '',

    QB: '#bc8f8f',    // Rosy brown
    WR: '#ffa07a',    // Salmon
    TE: '#fea8c3',    // Pink
    RB: '#ffa500',    // Orange
    OT: '#7A812D',    // Olive
    CB: '#30efdd',    // Light blue
    S: '#ffcc06',     // Golden yellow
    DL: '#CDDC39',    // Teal
    EDGE: '#df84ff',  // Purple
    LB: '#90ee90',    // Green
    iOL_C: '#64748B', // Slate
    iOL: '#148B96',   // Teal
    P: '#E18A36',     // Orange
    K: '#6f79ff',     // Blue
};

export const POSITION_BADGE_COLORS = {
    All:   { background: '#E2E8F0', border: '#94A3B8' },
    QB:    { background: '#EAD5D5', border: '#A66F6F' },
    WR:    { background: '#FFD7C7', border: '#D97745' },
    TE:    { background: '#FFD6E5', border: '#C65183' },
    RB:    { background: '#FFE4BF', border: '#FF9000' },
    OT:    { background: '#E8EACB', border: '#7A812D' },
    CB:    { background: '#D5EBFA', border: '#468DBB' },
    S:     { background: '#FFF2B3', border: '#C49A00' },
    DL:    { background: '#CCEEE9', border: '#258D80' },
    EDGE:  { background: '#DDD2F0', border: '#60359B' },
    LB:    { background: '#DDF0D3', border: '#609447' },
    iOL_C: { background: '#E1E6ED', border: '#64748B' },
	iOL: '#148B96',   // Teal
    P: '#E18A36',     // Orange
    K: '#344D91',     // Deep blue; previously identical to S
};

export const RANKIGS = [
	{ color: '#92C1DB', value: 'round1', label: 'Round 1', privilege: 1 },
	{ color: '#CCECA6', value: 'round1-2', label: 'Round 1-2', privilege: 2 },
	{ color: '#A58CDE', value: 'round2', label: 'Round 2', privilege: 3 },
	{ color: '#8190B9', value: 'round2-3', label: 'Round 2-3', privilege: 4 },
	{ color: '#BC979F', value: 'round3', label: 'Round 3', privilege: 5 },
	{ color: '#E8A5D8', value: 'round4-5', label: 'Round 4-5', privilege: 6 },
	{ color: '#89CEA0', value: 'round6-7', label: 'Round 6-7', privilege: 7 },
	{ color: '#D89186', value: 'udfa', label: 'UDFA', privilege: 99 },
];

export const THIS_YEAR = new Date().getFullYear();

export const ASPECT_RATIO = 1;
export const MIN_DIMENSION = 80;

/**
 * Primary team colours, keyed by a lowercase fragment of the team name.
 *
 * Lived in DraftPlayerV2/DraftPlayerConfig.jsx, where it coloured the team tiles. The result
 * card's header wedge wants the same colour, so it moved here rather than being duplicated —
 * one team, one colour, wherever it is drawn.
 *
 * Distinct from `TEAM_NEEDS[].color`, which is a lighter display tint and has no entry for some
 * teams; these are the real primaries.
 */

export const TEAM_COLORS = {
  raiders:               '#000000',
  jets:                  '#115740',
  cardinals:             '#97233f',
  titans:                '#4495d2',
  giants:                '#0b2265',
  browns:                '#311d00',
  commanders:            '#5a1414',
  'washington football': '#5a1414',
  saints:                '#d3bc8d',
  chiefs:                '#e31837',
  dolphins:              '#008e97',
  bears:                 '#0b162a',
  bengals:               '#fb4f14',
  bills:                 '#00338d',
  broncos:               '#0a2343',
  buccaneers:            '#a71930',
  chargers:              '#0080c6',
  colts:                 '#013369',
  cowboys:               '#002244',
  eagles:                '#004851',
  falcons:               '#a71930',
  '49ers':               '#aa0000',
  jaguars:               '#006778',
  lions:                 '#0076b6',
  packers:               '#203731',
  panthers:              '#0085cf',
  patriots:              '#002244',
  rams:                  '#003594',
  ravens:                '#24135f',
  seahawks:              '#002244',
  steelers:              '#000000',
  texans:                '#021018',
  vikings:               '#4f2683',
};

export const TEAM_SECOND_COLORS = {
  raiders:               '#a5acaf',
  jets:                  '#b1b3b6',
  cardinals:             '#000000',
  titans:                '#001532',
  giants:                '#a71930',
  browns:                '#ff3c00',
  commanders:            '#ffb612',
  'washington football': '#ffb612',
  saints:                '#000000',
  chiefs:                '#ffb612',
  dolphins:              '#fc4c02',
  bears:                 '#e64100',
  bengals:               '#000000',
  bills:                 '#c60c30',
  broncos:               '#fc4c02',
  buccaneers:            '#322f2b',
  chargers:              '#ffc20e',
  colts:                 '#a5acaf',
  cowboys:               '#b0b7bc',
  eagles:                '#a2aaad',
  falcons:               '#000000',
  '49ers':               '#b3995d',
  jaguars:               '#d7a22a',
  lions:                 '#b0b7bc',
  packers:               '#ffb612',
  panthers:              '#000000',
  patriots:              '#c60c30',
  rams:                  '#ffd100',
  ravens:                '#9a7611',
  seahawks:              '#a5acaf',
  steelers:              '#ffb612',
  texans:                '#eb0028',
  vikings:               '#ffc62f',
};

/**
 * Team abbreviations, keyed like TEAM_COLORS. The API sends only the nickname ('Chargers'); the
 * mobile team picker shows these instead because the full names don't fit four to a row.
 */
export const TEAM_ABBRS = {
  raiders:               'LV',
  jets:                  'NYJ',
  cardinals:             'ARI',
  titans:                'TEN',
  giants:                'NYG',
  browns:                'CLE',
  commanders:            'WAS',
  'washington football': 'WAS',
  saints:                'NO',
  chiefs:                'KC',
  dolphins:              'MIA',
  bears:                 'CHI',
  bengals:               'CIN',
  bills:                 'BUF',
  broncos:               'DEN',
  buccaneers:            'TB',
  chargers:              'LAC',
  colts:                 'IND',
  cowboys:               'DAL',
  eagles:                'PHI',
  falcons:               'ATL',
  '49ers':               'SF',
  jaguars:               'JAX',
  lions:                 'DET',
  packers:               'GB',
  panthers:              'CAR',
  patriots:              'NE',
  rams:                  'LAR',
  ravens:                'BAL',
  seahawks:              'SEA',
  steelers:              'PIT',
  texans:                'HOU',
  vikings:               'MIN',
};

/**
 * How much to enlarge each team's logo in the team card's header. The logo files carry different
 * amounts of empty space around the mark, so at one box size some read smaller than others; these
 * even them out. Keyed like TEAM_COLORS.
 */
export const TEAM_LOGO_SCALES = {
  raiders:               1,
  jets:                  1.21,
  cardinals:             1,
  titans:                1.18,
  giants:                1.11,
  browns:                1.11,
  commanders:            1.30,
  'washington football': 1.30,
  saints:                1,
  chiefs:                1.18,
  dolphins:              1.10,
  bears:                 1.13,
  bengals:               1.13,
  bills:                 1.15,
  broncos:               1.24,
  buccaneers:            1,
  chargers:              1.29,
  colts:                 1,
  cowboys:               1,
  eagles:                1.14,
  falcons:               1,
  '49ers':               1.22,
  jaguars:               1.21,
  lions:                 1.13,
  packers:               1.25,
  panthers:              1.27,
  patriots:              1.25,
  rams:                  1.15,
  ravens:                1.26,
  seahawks:              1.26,
  steelers:              1,
  texans:                1,
  vikings:               1,
};

export const TEAM_COLORS_V1 = {
  raiders:               '#000000',
  jets:                  '#115740',
  cardinals:             '#a4113e',
  titans:                '#4595d2',
  giants:                '#003c7f',
  browns:                '#472a08',
  commanders:            '#5a1414',
  'washington football': '#5a1414',
  saints:                '#d3bc8d',
  chiefs:                '#e31837',
  dolphins:              '#008e97',
  bears:                 '#0b1c3a',
  bengals:               '#fb4f14',
  bills:                 '#00338d',
  broncos:               '#0a2343',
  buccaneers:            '#bd1c36',
  chargers:              '#0080c6',
  colts:                 '#003b75',
  cowboys:               '#002a5c',
  eagles:                '#004851',
  falcons:               '#a71930',
  '49ers':               '#aa0000',
  jaguars:               '#007487',
  lions:                 '#0076b6',
  packers:               '#204e32',
  panthers:              '#0085ca',
  patriots:              '#002a5c',
  rams:                  '#003594',
  ravens:                '#29126f',
  seahawks:              '#003b75',
  steelers:              '#000000',
  texans:                '#00143f',
  vikings:               '#4f2683',
};

export const TEAM_COLORS_OLD = {
  raiders:               '#000000',
  jets:                  '#125740',
  cardinals:             '#97233f',
  titans:                '#002244',
  giants:                '#003c7f',
  browns:                '#311d00',
  commanders:            '#773141',
  'washington football': '#773141',
  saints:                '#9f8958',
  chiefs:                '#e31837',
  dolphins:              '#008e97',
  bears:                 '#0b162a',
  bengals:               '#fb4f14',
  bills:                 '#00338d',
  broncos:               '#002244',
  buccaneers:            '#d50a0a',
  chargers:              '#0080c6',
  colts:                 '#002c5f',
  cowboys:               '#003594',
  eagles:                '#004c54',
  falcons:               '#a71930',
  '49ers':               '#aa0000',
  jaguars:               '#006778',
  lions:                 '#0076b6',
  packers:               '#203731',
  panthers:              '#0085ca',
  patriots:              '#002244',
  rams:                  '#003594',
  ravens:                '#241773',
  seahawks:              '#002244',
  steelers:              '#1c1c1c',
  texans:                '#03202f',
  vikings:               '#4f2683',
};

/**
 * A team's entry in one of the tables above. Matched on `includes` rather than equality, because
 * the name arrives in several shapes across the app ('Jets', 'New York Jets', 'Washington Football
 * Team').
 */
const findTeamValue = (table, name) => {
	const lower = String(name).toLowerCase();
	const key = Object.keys(table).find(teamKey => lower.includes(teamKey));
	return key ? table[key] : null;
};

/** A team's primary colour. */
export const getTeamColor = (name = '') => findTeamValue(TEAM_COLORS, name) ?? '#1a2233';

/** A team's second colour — the stripe along the team card's header. Matched like getTeamColor. */
export const getTeamSecondColor = (name = '') => findTeamValue(TEAM_SECOND_COLORS, name) ?? '#a5acaf';

/** A team's abbreviation (TEAM_ABBRS). Matched like getTeamColor; the name's first 3 letters when unlisted. */
export const getTeamAbbr = (name = '') =>
  findTeamValue(TEAM_ABBRS, name) ?? String(name).slice(0, 3).toUpperCase();

/** A team's header logo scale (TEAM_LOGO_SCALES). Matched like getTeamColor; 1 when unlisted. */
export const getTeamLogoScale = (name = '') => findTeamValue(TEAM_LOGO_SCALES, name) ?? 1;
